'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var FunctionStateMap = {exports: {}};

exports.FunctionStateMap = FunctionStateMap;
